import { useAuthStore } from '@shared/store/auth'
import { checkPermissions } from '@shared/utils/permissions'
import typeOf from 'just-typeof'

export default {
  install: (app) => {
    app.directive('permissions', {
      mounted(el, binding) {
        const { value } = binding
        const authStore = useAuthStore()
        const userScopes = authStore.scopes
        const userRole = authStore.role
        if (value && typeOf(value) === 'object' && Object.keys(value).length) {
          const { scopes = [] } = value
          const isGuarded = scopes?.length
          if (!isGuarded) return true

          const hasPermissions =
            userScopes || userRole
              ? checkPermissions({ scopes }, userRole, userScopes)
              : false

          if (!hasPermissions) {
            app.$log.debug('v-permissions: does not have permissions')
            if (el.parentNode) el.parentNode.removeChild(el)
          }
        } else {
          app.$log.debug('v-permissions: no permissions object was passed')
        }
      }
    })

    app.config.globalProperties.$checkPermissions = ({ scopes = [] } = {}) => {
      const isGuarded = scopes?.length
      if (!isGuarded) return true
      const authStore = useAuthStore()
      const userScopes = authStore.scopes
      const userRole = authStore.role
      if (!userScopes && !userRole) return false
      return checkPermissions({ scopes }, userRole, userScopes)
    }

    app.provide(
      'checkPermissions',
      app.config.globalProperties.$checkPermissions
    )
  }
}
